const DEFAULT_CLOSE_DURATION_MS = 150;

export function navigationExitDuration() {
	if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return 0;

	const token = getComputedStyle(document.documentElement).getPropertyValue("--duration-quick").trim();
	const match = /^(\d+(?:\.\d+)?)(ms|s)$/.exec(token);
	if (!match) return DEFAULT_CLOSE_DURATION_MS;
	return Number(match[1]) * (match[2] === "s" ? 1000 : 1);
}
